<lib-component-switcher (closed)="handleClose()" [components]="components"></lib-component-switcher>
